import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Forum from "./Forum";

@Model()
class ForumPost extends ApplicationRecord {
  static jsonapiType = "forum_posts";

  @Attr() author: string;

  @Attr() body: string;

  @Attr() comment: boolean;

  @Attr({ persist: false }) createdAt: string;

  @Attr() externalId: string;

  @Attr() forumId: number;

  @Attr() publishedAt: string;

  @BelongsTo() source: Forum;

  @Attr() title: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() urlHash: string;
}

export default ForumPost;
